import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SellerService } from 'src/app/core';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-participation-chalenge-drawer',
  templateUrl: './participation-chalenge-drawer.component.html',
  styleUrls: ['./participation-chalenge-drawer.component.scss']
})
export class ParticipationChalengeDrawerComponent implements OnInit {
  @Input() challenge: any;
  @Input() isOpen = false;
  @Output() closed = new EventEmitter<void>();
  @Output() uploadCompletion = new EventEmitter<any>();

  showProofModal = false;
  uploadProgressFlag: boolean = false;
  uploadedResult: any = [];
  uploadedDocmentName: any;
   dndFlag: boolean = false;
  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  constructor(private sellerService: SellerService,) { }

  ngOnInit() { }

  close() {
    this.closed.emit();
  }

  onUploadCompletion() {
    this.uploadCompletion.emit(this.challenge);
  }

  setTime(date: string) {
    return new Date(new Date(date).getFullYear(), new Date(date).getMonth(), new Date(date).getDate());
  }

  formatDate(date: string) {
    const month = Number(date.substring(5, 7).replace(/^0+/, '')) - 1;
    const day = date.substring(8, 10).replace(/^0+/, '');
    const year = date.substring(0, 4);
    return `${this.months[month]} ${day}, ${year}`;
  }

  getStatus(check: any, completedBy: string, creationDate: string, startDate: string) {
    const lang = localStorage.getItem('selectedLanguage');
    let value: string;
    const createdDate = this.setTime(creationDate.split('T')[0]);
    const startOn = this.setTime(startDate.split('T')[0]);
    const completeByDate = this.setTime(completedBy.split('T')[0]);
    const currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    const isExpired = currentDate.getTime() > completeByDate.getTime();
    const creationOn = createdDate.getTime() < startOn.getTime();
    const pending = startOn.getTime() > currentDate.getTime();
    if (check) { value = this.formatDate(check); }
    if (lang === 'Korean') {
      value = '열다';
      if (!check && isExpired) { value = '닫은'; }
      if (creationOn && pending) { value = '대기 중'; }
      if (check) { value = ''; }
    } else if (lang === 'Japanese') {
      value = '開いた';
      if (!check && isExpired) { value = '閉まっている'; }
      if (creationOn && pending) { value = '保留中'; }
      if (check) { value = ''; }
    } else {
      value = 'Open';
      if (!check && isExpired) { value = 'Closed'; }
      if (creationOn && pending) { value = 'Pending'; }
      if (check) { value = ''; }
    }
    
    return value;
  }
  onFileDropped($event: any) {
    this.dndFlag = true;
    this.getUploadDoc($event);
  }
  getUploadDoc(eve: any) {
    this.uploadedResult = [];
    this.uploadProgressFlag = true;
    if (this.dndFlag) {
      this.uploadedDocmentName = eve[0];
    } else {
      this.uploadedDocmentName = eve.target.files[0];
    }
    setTimeout(() => {
      this.uploadCompletions();
    }, 1000);
  }
  uploadCompletions() {
    const uploadData = new FormData();
    uploadData.append("excelFile", this.uploadedDocmentName);
    const param =
      "?activityChallengeId=" +
      this.challenge.id +
      "&youSure=true";
    this.sellerService.uploadCompletion(uploadData, param).subscribe((res: any) => {
      if (res) {
        this.uploadProgressFlag = true;
        this.uploadedResult.push(res);
      }
    });
  }
  downloadSampleExcel() {
    const columnData = [['CCOID', 'Date of completion (MM/DD/YYYY)']];
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(columnData);
    workbook.SheetNames.push('First');
    workbook.Sheets['First'] = worksheet;
    const xlsbin = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
    const buffer = new ArrayBuffer(xlsbin.length);
    const array = new Uint8Array(buffer);
    for (let i = 0; i < xlsbin.length; i++) {
      array[i] = xlsbin.charCodeAt(i) & 0xff;
    }
    const blob = new Blob([buffer], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = 'Participation_Challenge_Completions_Upload.xlsx';
    anchor.click();
    window.URL.revokeObjectURL(url);
  }

  formatBytes(bytes: any, decimals: any) {
    if (bytes === 0) {
      return "0 Bytes";
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
}
